import Variable from '../../constants/constants.json';

const { handleExcception } = require('../../api/sentryExceptionHandler');
const { createRequest } = require('../../api/client');


export const saveNotification = async (data, notificationToken) => {
    const options = {
        url: `${Variable.backendUrl}/notifications/save`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${notificationToken}`
        },
        body: data
    };
    try {
        await createRequest(options);
    } catch (err) {
        handleExcception(err);
        throw new Error(err);
    }
};

export const specificNotification = async (id, notificationToken) => {
    const options = {
        url: `${Variable.backendUrl}/notifications/specific`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${notificationToken}`
        },
        qs: {
            id,
        }
    };
    try {
        const response = await createRequest(options);
        return response;
    } catch (err) {
        handleExcception(err);
        throw new Error(err);
    }
};

export const notificationList = async (query, notificationToken) => {
    const options = {
        url: `${Variable.backendUrl}/notifications/list`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${notificationToken}`
        },
        qs: query
    };
    try {
        const response = await createRequest(options);
        return response;
    } catch (err) {
        handleExcception(err);
        throw new Error(err);
    }
};

export const deleteSpecificNotification = async (payload, notificationToken) => {
    const options = {
        url: `${Variable.backendUrl}/notifications/remove`,
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${notificationToken}`
        },
        body: payload,
    };
    try {
        const response = await createRequest(options);
        return response;
    } catch (err) {
        handleExcception(err);
        throw new Error(err);
    }
};

export const toggleBanner = async (id, bannerEnabled,  notificationToken) => {
    const options = {
        url: `${Variable.backendUrl}/notifications/toggleBanner`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${notificationToken}`
        },
        body: { id , bannerEnabled},
    };
    try {
        const response = await createRequest(options);
        return response;
    } catch (err) {
        handleExcception(err);
        throw new Error(err);
    }
};
